<template>
  <div v-if="content.data">
 
    <Intro v-if="content.data.intro.visible"/>
    <Manifesto  v-if="content.data.manifesto.visible" />
    <BookInHand  v-if="content.data.book_in_hand.visible" />
    <Authors v-if="content.data.authors.visible" />
    <BookFragments  v-if="content.data.fragments.visible" />
    <SliderDishes v-if="content.data.dishes.visible" />
    <HowToGetBook v-if="content.data.how.visible" />
    <Protests v-if="content.data.protests.visible" />
    <FAQ v-if="content.data.faq.visible" />
    <Contributors  v-if="content.data.contributors.visible"/>
    <Share v-if="content.data.share.visible" />
  </div>
</template>

<script>
import Intro from "./home/Intro.vue";
import Manifesto from "./home/Manifesto.vue";
import BookInHand from "./home/BookInHand.vue";
import Authors from "./home/Authors.vue";
import BookFragments from "./home/BookFragments.vue";
import SliderDishes from "./home/SliderDishes.vue";
import HowToGetBook from "./home/HowToGetBook.vue";
import Protests from "./home/Protests.vue";
import FAQ from "./home/FAQ.vue";
import Contributors from "./home/Contributors.vue";
import Share from "./home/Share.vue";

export default {
  name: "MainPage",
  inject: ["content"],
  data() {
    return {
      title: "home page",
    };
  },
  components: {
    Intro,
    Manifesto,
    BookInHand,
    Authors,
    BookFragments,
    SliderDishes,
    HowToGetBook,
    Protests,
    FAQ,
    Contributors,
    Share,
  },
};
</script>
